import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '@/services/api';

// ===== PROMOTIONS PROGRAM HOOKS =====
export function usePromotionList(params?: { page?: number; limit?: number; search?: string; status?: string; type?: string }) {
  return useQuery({
    queryKey: ['promotions', 'list', params],
    queryFn: () => api.get('/promotions/v2', { params }).then((r) => r.data),
    retry: 0,
  });
}

export function useCreatePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: any) => api.post('/promotions/v2', body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}

export function useUpdatePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: any }) =>
      api.patch(`/promotions/v2/${id}`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}

export function useDeletePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/promotions/v2/${id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}

// ===== VOUCHERS HOOKS =====
export function useVoucherList(params?: { page?: number; limit?: number; search?: string; status?: string; voucher_type?: string }) {
  return useQuery({
    queryKey: ['promotions', 'vouchers', params],
    queryFn: () => api.get('/promotions/v2/vouchers', { params }).then((r) => r.data),
    retry: 0,
  });
}

export function useCreateVoucher() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: any) => api.post('/promotions/v2/vouchers', body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}

export function useUpdateVoucher() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: any }) =>
      api.patch(`/promotions/v2/vouchers/${id}`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}

export function useDeleteVoucher() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/promotions/v2/vouchers/${id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}

// ===== FLASH SALES HOOKS =====
export function useFlashSales() {
  return useQuery({
    queryKey: ['promotions', 'flash-sales'],
    queryFn: () => api.get('/promotions/v2/flash-sales').then((r) => r.data?.data ?? []),
    retry: 0,
  });
}

export function useFlashSalesAdmin(params?: { page?: number; limit?: number; status?: string }) {
  return useQuery({
    queryKey: ['promotions', 'flash-sales', 'admin', params],
    queryFn: () => api.get('/promotions/v2/flash-sales', { params }).then((r) => r.data),
    retry: 0,
  });
}

export function useCreateFlashSale() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: any) => api.post('/promotions/v2/flash-sales', body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}

export function useUpdateFlashSale() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: any }) =>
      api.patch(`/promotions/v2/flash-sales/${id}`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}

export function useDeleteFlashSale() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/promotions/v2/flash-sales/${id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['promotions'] }),
  });
}
